import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "antd";

const FloatingBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Show the back button on nested pages (e.g., /report/add) or collection and commission pages
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const isNestedPage = pathSegments.length > 1;
  const isCollectionOrCommission =
    location.pathname.includes("collection") ||
    location.pathname.includes("commission");

  if (!isNestedPage && !isCollectionOrCommission) {
    return null;
  }

  return (
    <Button
      onClick={() => navigate(-1)}
      className="fixed bottom-8 right-8 z-[9999] w-14 h-14 rounded-full bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white shadow-2xl hover:shadow-[0_10px_25px_-5px_rgba(0,0,0,0.5)] flex items-center justify-center border-0 transition-all duration-300 transform hover:scale-110"
      title="Go Back"
    >
      <ArrowLeft className="w-6 h-6" />
    </Button>
  );
};

export default FloatingBackButton;
